import dayjs, { Dayjs, extend, locale } from "dayjs";
import duration from "dayjs/plugin/duration";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/cs";

import { compareNullable } from "./other/compareNullable";

export type DatePickerFormat =
  | Date
  | Dayjs
  | null
  | number
  | string
  | undefined;

extend(duration);
extend(relativeTime);
extend(localizedFormat);
locale("cs");

export function dateToNowDifference(date: DatePickerFormat): null | string {
  if (!date) {
    return null;
  }

  const isValid = dayjs(date).isValid();

  return isValid ? dayjs(date).toNow(true) : "Invalid time value";
}

export const formatDateStringShort = (date: string): string => {
  return dayjs(date).format("ll");
};

export const formatDateStringFull = (date: string): string => {
  return dayjs(date).format("LL");
};

export const formatDateTimeStringFull = (date: string): string => {
  return dayjs(date).format("LLL");
};

export const compareDayjs = (a: Dayjs | null, b: Dayjs | null) =>
  compareNullable<Dayjs>(
    a,
    b,
    (a: Dayjs, b: Dayjs) => a.diff(b, "minute"),
    "start",
  );
